// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uW1UC","footnote":"styles_footnote__L3NT+","grayText":"styles_grayText__DvA2a","tableWrapper":"styles_tableWrapper__3oXUL"};